/**
 * @fileOverview Prepopulates the quote if details are in the URL.
 */
import React from 'react'
import { CreateEditCampaignForm } from './index'
import { urlGet } from './../../../../Utils/URL'
import { convertURLStringToCampaignDetails } from './../../../../Containers/Campaigns/CreateEditCampaign/util'
import ScriptLoader from './../../../../Components/ScriptLoader'
import { CONFIG } from './../../../../Config/config'
import { BUILDER_MAP_MODE } from '../../../BuilderMap/const'
import { formatFeaturesToOverlays } from '../../../BuilderMap/util'

const PreBuildQuote = props => {
  var quoteId = urlGet('quoteId')
  if (quoteId) {
    var quoteProps = convertURLStringToCampaignDetails(quoteId)
    if (quoteProps.bonusLimit || quoteProps.payoutPerConversion)
      quoteProps.bonusEnabled = true
    if (quoteProps.redemptionTime) {
      quoteProps.baRedemptionPeriod = quoteProps.redemptionTime
      delete quoteProps.redemptionTime
    }
    if (quoteProps.printingCostPerFlyer) {
      // Currently its in micro cents. Convert it to a cent value
      quoteProps.printingCostPerFlyer = quoteProps.printingCostPerFlyer / 100
    }
    if (quoteProps.missions) {
      quoteProps.prebuiltOverlays = formatFeaturesToOverlays(
        quoteProps.missions.map(feature => ({
          ...feature,
          geometry: {
            coordinates: [feature.geometry.coordinates],
          },
          properties: {
            id: (Math.random() * 9999999999999).toString(36).slice(0, 5),
            customToggled: true,
          },
        })),
        {
          mode: BUILDER_MAP_MODE.TOGGLE,
        },
      )
      // TODO Be able to pass pre selecting missions to a draft quote.
    }
  }
  return <CreateEditCampaignForm {...props} {...quoteProps} />
}

export default props => (
  <ScriptLoader
    src={`https://maps.googleapis.com/maps/api/js?key=${
      CONFIG.GOOGLE_API_KEY
    }&libraries=drawing`}
  >
    <PreBuildQuote {...props} />
  </ScriptLoader>
)



// WEBPACK FOOTER //
// ./src/Containers/Form/Campaigns/CreateEditCampaign/PreBuild.js